import config from "../config"
const base_url = config.base_url
export const login = () =>{
    
}

export const getOTPoptions = () =>{
    return fetch(base_url+'login/OTP/options', {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
            'credentials':'include'
        },
        credentials:'include'
        })
}